import { bootstrapApplication } from '@angular/platform-browser';
import { buildAppConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { EnvConfig } from './app/core/env-config';
import { environment } from './environments/environment';

function loadEnv(): Promise<EnvConfig> {
    if (environment.envConfig) {
        return Promise.resolve(environment.envConfig as unknown as EnvConfig);
    }
    return fetch('assets/settings/env.json').then(res => res.json());
}

loadEnv()
    .then((env: EnvConfig) => bootstrapApplication(AppComponent, buildAppConfig(env)))
    .catch(err => console.error('Failed to load env config:', err));
